// extracted by mini-css-extract-plugin
export default {"container":"LM-z","topReviewHeading":"MM-z","criticalReview":"NM-z","favorableReview":"OM-z","vsSeparator":"PM-z"};